import { useState } from 'react'
import { Select, Divider, Button, Space } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { createClientMaterial } from '$api/client'

const sameMaterial = (a, b) => a.trim().toLowerCase() === b.trim().toLowerCase()

export function CreatableSelectLabelInValue({
  useOptions,
  onChange,
  value,
  placeholder,
}) {
  const { data: options, isLoading: optionsAreLoading } = useQuery({
    ...useOptions?.(),
    enabled: !!useOptions,
  })

  const queryClient = useQueryClient()
  const createMaterialMutation = useMutation({
    mutationFn: createClientMaterial,
    onSuccess: (_data) => {
      queryClient.invalidateQueries({
        queryKey: ['clientMaterialsListForDropdown'],
      })
    },
  })

  const [search, setSearch] = useState('')
  const exists = search && options.some((o) => sameMaterial(o.label, search))
  const canCreate = !!search && !exists

  const handleAdd = async () => {
    if (!canCreate) return
    const newMaterial = await createMaterialMutation.mutateAsync({
      name: search.trim(),
    })
    onChange?.(newMaterial.value)
    setSearch('')
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && canCreate) {
      e.preventDefault()
      handleAdd()
    }
  }

  return (
    <Select
      showSearch
      placeholder={placeholder}
      loading={optionsAreLoading}
      options={options}
      value={value}
      onChange={onChange}
      onSearch={setSearch}
      onInputKeyDown={handleKeyDown}
      filterOption={(input, option) =>
        String(option?.label ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      dropdownRender={(menu) => (
        <>
          {menu}
          {canCreate && (
            <>
              <Divider style={{ margin: '8px 0' }} />
              <div style={{ padding: '8px 8px' }}>
                <Space>
                  <Button
                    type="link"
                    icon={<PlusOutlined />}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={handleAdd}
                  >
                    “{search}”
                  </Button>
                </Space>
              </div>
            </>
          )}
        </>
      )}
    />
  )
}
